export interface IEtcTransactionDetails {
    etcId: string;
    etcNo: string;
    etcVersionNo: string;
    tcOrganicFarmStandard: string[];
    tcStandard: string[];
    tcStatus: string;
    tcAmendmentReason: string;
    tcInvalidationReason: string;
    tcPlaceOfIssue: string;
    tcDateOfIssue: string; // Use `Date` if you want to handle it as a Date object
    tcLastUpdated: string;
    tcCbLicensingCode: string;
    tcUsdaNopCompliantFlag: string;
    tcApplicationReceived: string;
    tcApplicationComplete: string;
    tcDelayReason: string;
    tcCreationDate: string; // Use `Date` if you want to handle it as a Date object
    tcCreatedBy: string;
    etcAssociatedPoNumber: string;
    etcTraceabilityProviderCode:string; 
    additionalProp1: Record<string, unknown>;
}

export const etcTransactionCertificateInitValue: IEtcTransactionDetails = {
    etcId: "",
    etcNo: "",
    etcVersionNo: "",
    tcOrganicFarmStandard: [],
    tcStandard: [],
    tcStatus: "",
    tcAmendmentReason: "",
    tcInvalidationReason: "",
    tcPlaceOfIssue: "",
    tcDateOfIssue: "",
    tcLastUpdated: "",
    tcCbLicensingCode: "",
    tcUsdaNopCompliantFlag: "",
    tcApplicationReceived: "",
    tcApplicationComplete: "",
    tcDelayReason: "",
    tcCreationDate: "",
    tcCreatedBy: "",
    etcAssociatedPoNumber: "",
    etcTraceabilityProviderCode:"",
    additionalProp1: {},
};

export const mapJsonToEtcTransactionCertificate=(json: any): IEtcTransactionDetails=>{
    let isValidDate = true;
    const [day, month, year] = json.tcCreationDate.split("-");

    if (!day || !month || !year) {  
        isValidDate = false;
    }
    return {
        etcId: json.etcId,
        etcNo: json.etcNo,
        etcVersionNo: json.etcVersionNo,
        tcOrganicFarmStandard: json.tcOrganicFarmStandard || [],
        tcStandard: json.tcStandard || [],
        tcStatus: json.tcStatus,
        tcAmendmentReason: json.tcAmendmentReason,
        tcInvalidationReason: json.tcInvalidationReason,
        tcPlaceOfIssue: json.tcPlaceOfIssue,
        tcDateOfIssue: json.tcDateOfIssue ? json.tcDateOfIssue: "",
        tcLastUpdated: json.tcLastUpdated,
        tcCbLicensingCode: json.tcCbLicensingCode,
        tcUsdaNopCompliantFlag: json.tcUsdaNopCompliantFlag === 'Y'?"Yes":"No",
        tcApplicationReceived: json.tcApplicationReceived,
        tcApplicationComplete: json.tcApplicationComplete,
        tcDelayReason: json.tcDelayReason,
        tcCreationDate: isValidDate ? new Date(json.tcCreationDate).toISOString() : json.tcCreationDate,
        tcCreatedBy: json.tcCreatedBy,
        etcAssociatedPoNumber: json.etcAssociatedPoNumber,
        etcTraceabilityProviderCode: json.etcTraceabilityProviderCode,
        additionalProp1: json.additionalProp1 || {},
    };
}